import React from "react";
import AddClient from "./AddClient";
export const AddClientIndex: React.FC = () => {

    return (
        <AddClient/>
    )
} 